import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';
import { redirectAfterAuth } from '../utils/profileSession';

const API = getApiBaseUrl();

function passwordStrength(p) {
    if (!p) return 0;
    let s = 0;
    if (p.length >= 8) s++;
    if (/[0-9]/.test(p)) s++;
    if (/[a-zA-Zа-яА-Я]/.test(p)) s++;
    if (p.length >= 12) s++;
    return s;
}

export default function ChangePasswordPage() {
    const { t } = useTranslation('auth');
    const token = sessionStorage.getItem('changePasswordToken');
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const strength = passwordStrength(password);

    async function handleSubmit(e) {
        e.preventDefault();
        if (password !== confirm) {
            setError(t('errors.passwordsMismatch'));
            return;
        }
        setLoading(true);
        setError('');
        try {
            const res = await axios.post(
                `${API}/auth/change-temp-password`,
                { newPassword: password },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            sessionStorage.removeItem('changePasswordToken');
            redirectAfterAuth(res.data);
        } catch (err) {
            setError(err.response?.data?.message || t('errors.changeFailed'));
        } finally {
            setLoading(false);
        }
    }

    if (!token) {
        window.location.href = '/login';
        return null;
    }

    return (
        <div style={{
            minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'linear-gradient(135deg, #1A1A1A 0%, #16213e 50%, #3d1515 100%)', padding: 20
        }}>
            <div style={{ background: '#fff', borderRadius: 20, padding: 36, maxWidth: 420, width: '100%' }}>
                <h1 style={{ margin: '0 0 8px', fontSize: 22 }}>{t('changePassword.title')}</h1>
                <p style={{ color: '#64748b', fontSize: 14, marginBottom: 24 }}>
                    {t('changePassword.subtitle')}
                </p>
                <form onSubmit={handleSubmit}>
                    <label style={{ fontSize: 13, fontWeight: 600 }}>{t('changePassword.newPassword')}</label>
                    <input
                        type="password"
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                        required
                        style={{ width: '100%', padding: 12, marginTop: 6, marginBottom: 8, borderRadius: 10, border: '1.5px solid var(--sp-gray-200)', boxSizing: 'border-box' }}
                    />
                    <div style={{ height: 4, background: '#e2e8f0', borderRadius: 2, marginBottom: 16 }}>
                        <div style={{
                            width: `${(strength / 4) * 100}%`, height: '100%', borderRadius: 2,
                            background: strength < 2 ? '#ef4444' : strength < 3 ? '#f59e0b' : '#22c55e',
                            transition: 'width 0.2s'
                        }} />
                    </div>
                    <label style={{ fontSize: 13, fontWeight: 600 }}>{t('changePassword.confirmPassword')}</label>
                    <input
                        type="password"
                        value={confirm}
                        onChange={e => setConfirm(e.target.value)}
                        required
                        style={{ width: '100%', padding: 12, marginTop: 6, marginBottom: 16, borderRadius: 10, border: '1.5px solid var(--sp-gray-200)', boxSizing: 'border-box' }}
                    />
                    {error && <p style={{ color: '#c62828', fontSize: 13 }}>{error}</p>}
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%', padding: 13, background: '#1A1A1A', color: '#fff',
                            border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer'
                        }}
                    >
                        {loading ? t('changePassword.saving') : t('changePassword.saveAndLogin')}
                    </button>
                </form>
            </div>
        </div>
    );
}
